module.exports = __webpack_public_path__ + "static/img/partner-logo-8.b74f7c8d.png";